<template>
  <span class="fflag flex-shrink-0 flex-grow-0" :class="`fflag-${flag}`" :title="`Language: ${country}`" />
</template>

<script>
  import { getCountry } from '@/utils'
  export default {
    name: 'UiFlag',
    props: {
      country: {
        type: String,
        default: '',
      },
    },
    computed: {
      flag() {
        return getCountry(this.country)
      },
    },
  }
</script>
